/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BooleanResponse } from '../../models/boolean-response';

export interface DeleteNewsFeedItem$Params {
  id: number;
}

export function deleteNewsFeedItem(http: HttpClient, rootUrl: string, params: DeleteNewsFeedItem$Params, context?: HttpContext): Observable<StrictHttpResponse<BooleanResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteNewsFeedItem.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BooleanResponse>;
    })
  );
}

deleteNewsFeedItem.PATH = '/rest/newsfeed/{id}';
